import React, { useEffect, useState } from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import IconWebSite from "../../assets/svgs/article-website-icon.svg";
import IconWhitePaper from "../../assets/svgs/article-whitepaper-icon.svg";
import IconDetailedRules from "../../assets/svgs/article-detailed-rules-icon.svg";

import { ArticleTemplate } from "../../components/ArticleTemplateComponents";
import SignUpButton from "../../components/SignUpButton";
import LinkWithIcon from "../../components/LinkWithIcon";
import ZLaunchDetails from "./ZLaunchDetails";
import { getTickersSummary } from "../../client";

import "./style.scss";

const ProjectDetailsArticleLayout = ({
  coinInfo,
  currencies,
  currentUrl,
  coinInsightLink,
  t,
  children,
}) => {
  const { acfCoinInfo, excerpt, content, categories } = coinInfo;
  const {
    ciHomeFullName: title,
    ciTickerSymbol: tickerSymbol,
    ciIcon,
    websiteLink,
    detailedRuleLink,
    whitepaperLink,
  } = acfCoinInfo;
  const coinType = categories?.nodes[0]?.slug;
  const isZLaunchCoin = coinType === "zlaunch-coin";
  const [currentMarket, setCurrentMarket] = useState({});

  useEffect(() => {
    const getCurrentMarket = async () => {
      const data = await getTickersSummary(tickerSymbol, currencies);
      setCurrentMarket(data);
    };

    getCurrentMarket();
  }, []);

  return (
    <ArticleTemplate contentClassNames="project-details-article">
      <>
        <div className="project-details-article__title d-flex justify-content-center align-items-center text-dark mb-4">
          <img className="mr-2" src={ciIcon.localFile.publicURL} alt="" />
          <h1 className="mb-0">{title}</h1>
        </div>
        <div
          className="text-center text-dark"
          dangerouslySetInnerHTML={{ __html: excerpt }}
        />

        <div className="d-flex flex-wrap justify-content-center my-3">
          {websiteLink && (
            <LinkWithIcon
              className="text-center mx-3 my-1"
              to={websiteLink?.trim()}
              icon={<IconWebSite />}
              label={t("coinInfo.projectDetail.website")}
            />
          )}
          {whitepaperLink && (
            <LinkWithIcon
              className="text-center mx-3 my-1"
              to={whitepaperLink?.trim()}
              icon={<IconWhitePaper />}
              label="Whitepaper"
            />
          )}
          {(detailedRuleLink || coinInsightLink) && (
            <LinkWithIcon
              className="text-center mx-3 my-1"
              to={detailedRuleLink?.trim() || coinInsightLink?.trim()}
              icon={<IconDetailedRules />}
              label={
                detailedRuleLink
                  ? t("coinInfo.projectDetail.detailedRules")
                  : "Coin Insight"
              }
            />
          )}
        </div>

        <div className="divider" />

        <div className="project-details-article__share-social d-flex flex-wrap justify-content-center align-items-center text-dark">
          <span className="mr-md-3">Share this article</span>
          <div>
            <FacebookShareButton url={currentUrl}>
              <FacebookIcon size={36} round={true} />
            </FacebookShareButton>
            <TwitterShareButton url={currentUrl}>
              <TwitterIcon size={36} round={true} />
            </TwitterShareButton>
            <LinkedinShareButton url={currentUrl}>
              <LinkedinIcon size={36} round={true} />
            </LinkedinShareButton>
          </div>
        </div>

        {currentMarket &&
          Object.entries(currentMarket).every(([currency, data]) => {
            return Number(data.last_price) > 0;
          }) &&
          Object.keys(currentMarket).length > 0 && (
            <div className="project-details-article__current-market d-flex flex-wrap justify-content-center justify-content-md-between align-items-center text-dark">
              <span className="title">Current Market</span>
              <table className="details mx-4">
                {Object.entries(currentMarket).map(([currency, data]) => (
                  <tr>
                    <th className="">
                      {tickerSymbol}/{currency}
                    </th>

                    <th className="">
                      {currency === "THB" ? "฿" : "$"}
                      {new Intl.NumberFormat("en-US", {
                        useGrouping: true,
                      }).format(parseFloat(data.last_price).toFixed(2))}
                    </th>

                    <th
                      className={`details__percent  ${
                        data.price_change_percent_24h >= 0 ? "plus" : "minus"
                      }`}
                    >
                      {data.price_change_percent_24h >= 0 ? "+" : ""}
                      {data.price_change_percent_24h?.toFixed(2)}%
                    </th>
                  </tr>
                ))}
              </table>
              <SignUpButton className="button button-primary mt-3 mt-md-0">
                Trade Now
              </SignUpButton>
            </div>
          )}

        {isZLaunchCoin && (
          <>
            <ZLaunchDetails
              token={{
                ticker: tickerSymbol,
                name: title,
              }}
            />

            <div className="divider" />
          </>
        )}

        <div
          className="project-details-article__content mt-5"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        <div className="divider py-5" />

        {children}
      </>
    </ArticleTemplate>
  );
};

export default ProjectDetailsArticleLayout;
